<template>
    <div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Partidas Presupuestarias</h4>
            <p>Registro y Modificacion de Partidas Presupuestarias</p>        
        </div>
        <label for="captain_download" class="badge badge-info col-12 col-sm-2 offset-sm-5">TIPO</label>
        <div class="form-group row">
                
                
                <div class="btn-group col-sm-6 offset-sm-4 btn-group-toggle" data-toggle="buttons">
                    <label class="btn btn-success active" @click="mTypeBuget">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"  value="expenses"  checked> Egreso
                    </label>
                    <label class="btn btn-success" @click="mTypeBuget">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="entry" > Ingreso
                    </label>
                </div>
            </div>
    </div>
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#nav-capitan" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Registro</a>
            <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-new-capitan" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="edit" /> Modificacion</a>
        </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="nav-capitan" role="tabpanel" aria-labelledby="nav-capitan-tab">
            <br>
            <div class="row">
                <div class="col-12 col-sm-2 offset-sm-8">
                    <button class="btn btn-outline-success" @click="viewBudget"><font-awesome-icon icon="th-list"></font-awesome-icon> Ver Partidas {{ cTypeBudget }}</button>
                </div>
                <!-- <div class="col-12 col-sm-2">
                    <button class="btn btn-outline-dark">Ejemplo</button>
                </div> -->
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 offset-sm-3 alert alert-danger" align="center">
                    Registrar Partida Presupuestaria de {{ cTypeBudget }}
                </div>
            </div>
                           
            <div class="form-group row">
                <label for="new_code_budget" class="col-sm-3 col-from-label">Codigo Presupuestario</label>
                <div class="col-sm-4">
                    <input type="number" class="form-control" placeholder="Ejm. 21100" name="new_code_budget" id="new_code_budget" v-model="newBudget.code">
                </div>
                <div class="col-sm-4">
                    {{ cValidate }}
                </div>
            </div>

            <div class="form-group row">
                <label for="new_code_budget" class="col-sm-3 col-from-label">Titulo Partida</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" placeholder="Ejm. COBROS POR OPERACION" name="new_code_budget" id="new_code_budget" v-model="newBudget.title">
                </div>
            </div>

            <div class="form-group row">
                <label for="new_code_budget" class="col-sm-3 col-from-label">Glosa/Descripcion</label>
                <div class="col-sm-8">
                    <textarea name="description_new_budget" id="description_new_budget" class="form-control" cols="30" rows="5" placeholder="Ejm. Recursos Generados por cobros en operaciones ....." v-model="newBudget.description"></textarea>
                </div>
            </div>

            <div align="center">
                <transition mode="in-out">                    
                    <button v-if="btnValidateVisible" class="btn btn-danger" :disabled="cValidateDisabled"  @click="mValidateBudget"><font-awesome-icon icon="save" size="2x"></font-awesome-icon><br>Guardar</button>
                </transition>                
            </div>
        </div>
        <!-- end first tab -->

        <div class="tab-pane fade" id="nav-new-capitan" role="tabpanel" aria-labelledby="nav-new-tab">
            <br>
            <div class="form-group row">
                <div class="col-12 col-sm-4 offset-sm-4">
                    <button class="btn btn-block btn-lg btn-danger" @click="callBudgetEdit"><font-awesome-icon icon="list"></font-awesome-icon> Listar Partidas de {{ cTypeBudget }}</button>
                </div>
            </div>

            <transition name="fade" mode="out-in">
            <div class="col-12 table-responsive" v-if="BudgetRegister.length > 0" >
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Codigo</th>
                            <th scope="col">Titulo Partida</th>
                            <th scope="col">Descripcion</th>
                            <th scope="col">Editar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(budget, index) in BudgetRegister" :key="budget.code">
                            <td>{{ index+1 }}</td>
                            <td>{{ budget.code }}</td>
                            <td><textarea rows="3" cols="10" disabled :id="`title_budget_${index}`" class="form-control" v-model="budget.glosa"></textarea></td>
                            <td><textarea class="form-control" disabled :id="`description_budget_${index}`" cols="30" rows="5" v-model="budget.description"></textarea></td>
                            <td>
                                <button class="btn btn-warning" :id="`btn_edit_${index}`" @click="editRegisterBudget(index)"><font-awesome-icon icon="edit" /></button>

                                <div style="display:none" :id="`edit_cancel_budget_${index}`">
                                    <button class="btn btn-success" @click="saveBudget(index)"><font-awesome-icon icon="save" /></button>
                                    <button class="btn btn-danger" @click="cancelEditBudget(index)"><font-awesome-icon icon="times-circle" /></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </transition>
        </div>
        <!-- end  second tab -->
    </div>
    <modal-loading :id-modal="idModalProgress" :title="titleModal" :status-send="sendDispatch" ></modal-loading>
    <modal-view :id-modal-view="idModalContent" :title="titleModalView" :is-xl="typeModal" :content="contentModalView" ></modal-view>
</div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios';
import vue from 'vue';
const qs =require('qs');

import modalLoading from '../modal/modalLoading';
import modalView from '../modal/modalView';


export default {
    name:'budget-conf',
    data(){
        return{
            typeBudget:'expenses',
            typeBudgetEdit:'expenses',
            btnValidateVisible:true,
            newBudget:{
                code:null,
                title:null,
                description:null
            },
            idModalProgress:'loadChargeBudget',
            sendDispatch:true,
            titleModal:'Registrando',
            idModalContent:'ConfigBudget',
            titleModalView:'Configuracion',
            contentModalView:'<h5>Sin Registros</h5>',
            typeModal:true,
            BudgetRegister:[],
            BudgetEdit:[]
        }
    },
    methods:{
        editRegisterBudget(i){
            // console.log(`el valor a editar es ${i}`);
            let tm = document.getElementById('title_budget_'+i);
            let dm = document.getElementById('description_budget_'+i);
            let btn_edit= document.getElementById(`btn_edit_${i}`);
            let save_cancel= document.getElementById(`edit_cancel_budget_${i}`);
            let ab={
                code:null,
                glosa:null,
                description:null
            }

            tm.removeAttribute('disabled');
            dm.removeAttribute('disabled');
            btn_edit.style.display='none';
            // save_cancel.style.display = 'block';
            save_cancel.removeAttribute('style');
            // validar si ya esta registrado el codigo
            ab.code=this.BudgetRegister[i].code;
            ab.glosa=this.BudgetRegister[i].glosa;
            ab.description=this.BudgetRegister[i].description;
            this.BudgetEdit.push(ab);
            
            // aqui buscamos el codigo que se va a editar y guardarlo en una variable por si se decide no guardar
        },
        cancelEditBudget(i){
            // al cancelar la edicion se debe vaciar los datos del auxiliar al original de los datos
            let tm = document.getElementById('title_budget_'+i);
            let dm = document.getElementById('description_budget_'+i);
            let btn_edit= document.getElementById(`btn_edit_${i}`);
            let save_cancel= document.getElementById(`edit_cancel_budget_${i}`);
            
            let code_aux;
            let auxBudget;
            let idel;
            // obtenemos el codigo del original y lo buscamos en el auxiliar para luego vaciarlo
            code_aux=this.BudgetRegister[i].code;
            toastr.warning(`Se ha cancelado la modificacion del registro ${code_aux}`, 'Advertencia');
            // console.log(this.BudgetEdit);
            // vaciamos del auxiliar al original
            this.BudgetEdit.forEach((v, key)=>{
                if(code_aux===v.code){
                    auxBudget={
                        description:v.description,
                        glosa:v.glosa
                    }
                    idel=key;
                }
            });
            // posteriormente eliminar la copia en el auxiliar
            
            this.BudgetEdit.splice(idel, 1);
            // console.log(this.BudgetEdit);
            // console.log(`el valor a reemplazar es ${auxBudget}`);
            
            this.BudgetRegister[i].description=auxBudget.description;
            this.BudgetRegister[i].glosa=auxBudget.glosa;

            tm.setAttribute('disabled', 'disabled');
            dm.setAttribute('disabled', 'disabled');
            btn_edit.removeAttribute('style');
            save_cancel.style.display='none';
            

        },
        async saveBudget(i){
            let idel;
                let code_aux;
                let sendAux;

                code_aux=this.BudgetRegister[i].code;
                this.BudgetEdit.forEach((v, key)=>{
                    if(code_aux===v.code){
                        idel=key;
                    }
                });
                // posteriormente eliminar la copia en el auxiliar
                
                this.BudgetEdit.splice(idel, 1);
                // enviamos al servidor la nueva actualizacion del codigo
                sendAux={
                    type_code:this.BudgetRegister[i].t_code,
                    code:this.BudgetRegister[i].code,
                    title:this.BudgetRegister[i].glosa,
                    description:this.BudgetRegister[i].description
            }
            if(sendAux.title!==null && sendAux.title!==''){
                let tm = document.getElementById('title_budget_'+i);
                let dm = document.getElementById('description_budget_'+i);
                let btn_edit= document.getElementById(`btn_edit_${i}`);
                let save_cancel= document.getElementById(`edit_cancel_budget_${i}`);
                
                tm.setAttribute('disabled', 'disabled');
                dm.setAttribute('disabled', 'disabled');
                btn_edit.removeAttribute('style');
                save_cancel.style.display='none';
                console.log(sendAux.title);
            

                this.titleModal='Actualizando';
                this.activeModal(this.idModalProgress);
                // let responseServ=await axios.post(`updateBudget`, qs.stringify(sendAux));
                let responseServ=await axios.post(`updateBudget?api_token=${Vue.auth.getToken()}`, qs.stringify(sendAux));
                

                setTimeout(()=>{
                    if(responseServ.data.status){
                        toastr.success(responseServ.data.response, 'Exito');
                    }else{
                        toastr.error(responseServ.data.response, 'Error');
                    }
                    this.inactiveModal(this.idModalProgress);
                }, 500)
            }else{
                toastr.warning(`Opss el campo del titulo de partida del codigo ${sendAux.code} debe contener datos, registrelos por favor`, 'Advertencia');
            }
        },
        mTypeBuget(){            
            var radios=$("input[type=radio]").parents('label');
            let radioV;
            setTimeout(()=>{
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
                // console.log(radioV);
                
                this.typeBudget=radioV;
            }, 200)
        },
        async mValidateBudget(){
            // aca se debe mostrar si el codigo es valido o no lo es dependiendo de su nivel de jerarquia
            // console.log(this.newBudget);
            let nDtsB={
                type_code:this.typeBudget,
                code:this.newBudget.code,
                title:this.newBudget.title,
                description:this.newBudget.description
            }
            // console.log(nDtsB);
            // let dts=JSON.stringify(nDtsB);
            this.titleModal='Registrando';
            this.activeModal(this.idModalProgress);
            // let rb= await axios.post(`insertBudget`, qs.stringify(nDtsB));
            let rb= await axios.post(`insertBudget?api_token=${Vue.auth.getToken()}`, qs.stringify(nDtsB));
            setTimeout(()=>{
                if(rb.data.status){
                    toastr.success(rb.data.response, 'Exito');
                    this.newBudget.code=null;
                    this.newBudget.title=null;
                    this.newBudget.description=null;
                }else{
                    toastr.error(rb.data.response, 'Error');
                }
                this.inactiveModal(this.idModalProgress);
            }, 500)       
            
            // console.log(rb.data.status);
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        },
        async viewBudget(){
            // let gb=await axios.get(`getBudget/${this.typeBudget}`);
            let gb=await axios.get(`getBudget/${this.typeBudget}?api_token=${Vue.auth.getToken()}`);
            
            let auxt=this.typeBudget == 'expenses' ? 'Gasto':'Ingreso';
            this.titleModalView=`Partidas Presupuestarias de ${auxt}`;
            
            let ad=gb.data;
            let dt='';
            // base de columnas de tablas es 5 ya que son solo 5 digitos
            dt=`<table class="table table-responsive">`;
            
            ad.forEach(e => {
                // verificar si tiene padre y verificar si el anterior es su padre si lo es subir un nivel mas
                
                // si es cero es parent
                if(parseInt(e.code_parent)!==0){
                    // level 1
                        dt+=`<tr>
                            <td align="right">${e.code}</td>
                            <td colspan="4" align="left">${e.glosa}<br>
                            ${e.description}</td>
                        </tr>`;
                }else{
                    // es cero y por ende es parent
                    // registramos el parent
                    // level 0
                    // registramos el codigo anterior
                    
                    dt+=`<tr class="text-white bg-primary">
                            <td align="right">${e.code}</td>
                            <td colspan="4" align="left">${e.glosa}<br>
                            ${e.description}</td>
                    </tr>`;
                }
            });
            dt+=`</table>`;
            this.contentModalView=dt;
            this.activeModal(this.idModalContent);
        },
        async callBudgetEdit(){
            this.BudgetRegister=[];
            
            // let gb=await axios.get(`getBudget/${this.typeBudget}`);
            let gb=await axios.get(`getBudget/${this.typeBudget}?api_token=${Vue.auth.getToken()}`);
            this.BudgetRegister=gb.data;
        }

    },
    computed:{
        cValidate(){
            let nc='00000';
            let a=this.newBudget.code;
            let ca= a ? a.length:0;

            // console.log(this.newBudget.code);
            if(ca<=5 && ca>0){
                let nb=5-ca;
                // console.log(nb);
                let v=this.newBudget.code;
                let c='';
                for(let i=1; i<=nb; i++){
                    c=c+'0';
                }
                nc=this.newBudget.code+c;
            }else{
                this.newBudget.code=null;
            }
            return nc;
        },
        cValidateDisabled(){
            let code=this.newBudget.code ? this.newBudget.code : null;
            let title=this.newBudget.title ? this.newBudget.title : null;
            let description=this.newBudget.description ? this.newBudget.description : null;

            if( code !== null && title !== null &&  description !== null ){            
                return false;
            }else{            
                return true;
            }
        },
        cValueCode(){
            return this.newBudget.code !== null ? false:true;
        },
        cTypeBudget(){
            if(this.typeBudget === 'expenses'){
                return 'Egreso';
            }else{
                return 'Ingreso';
            }
        }
    },
    components:{
        'modal-loading': modalLoading,
        'modal-view':modalView
    }
}
</script>



// WEBPACK FOOTER //
// src/components/finanzas/BudgetConf.vue